import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles, Theme, Grid, } from '@material-ui/core';
import config from '../../config';

const useStyles = makeStyles((theme: Theme) => ({
    title: {
        marginLeft: '50px',
        marginTop: '100px'
    },
    button: {
        marginLeft: '50px',
        marginTop: '10px'
    }
}));

export const LogoutPage = () => {
    const classes = useStyles();
    const login = async () => window.location.replace(config.loginPageUrl)

    return (
        <Grid container spacing={3} alignContent="stretch" justify="center"
            alignItems="center" direction="column">

            <h2 className={classes.title} >Uloskirjautuminen onnistui</h2>

            <Button variant="contained" color="primary" onClick={login} className={classes.button}>
                Kirjaudu AD-tunnuksella
            </Button>
        </Grid>
    );
}